import React, { Component } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import axios from "axios";
import * as appConst from "../../Common/constants";

export default class EquipmentList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      equipments: [],
      spinnerClass: "collapse",
      dataClass: "",
      dummy: { _id: "NA" }
    };
  }

  componentDidMount() {
    this.showBusy(true);
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/equipment"
      )
      .then(response => {
        this.setState({ equipments: response.data });
      })
      .catch(function(error) {
        console.log(error);
      });
    this.showBusy(false);
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  render() {
    return (
      <>
        <h5 align="center">Equipment List</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="ag-theme-blue" style={this.getHeight()}>
            <div>
              <button
                onClick={this.onAddClick}
                className="btn btn-primary btn-sm mb-2 mr-2"
                name="Income"
              >
                Add Equipment
              </button>
              <button
                onClick={this.onEditClick}
                className="btn btn-primary btn-sm mb-2 mr-2"
              >
                Edit Equipment
              </button>
              <button
                onClick={this.onDisposeClick}
                className="btn btn-primary btn-sm mb-2"
              >
                Dispose
              </button>
            </div>
            <AgGridReact
              rowData={this.state.equipments}
              pagination={true}
              enableSorting={true}
              enableFilter={true}
              onGridReady={this.onGridReady}
              paginationAutoPageSize={true}
            >
              <AgGridColumn field="_id" hide="true" />
              <AgGridColumn
                field="eno"
                headerName="Equipment #"
                width={80}
                checkboxSelection
                //filter={false}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="name"
                headerName="Name"
                width={200}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="stock.stock"
                headerName="In Stock"
                width={80}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="stock.damage"
                headerName="Damaged"
                width={80}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="stock.inuse"
                headerName="In Use"
                width={80}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                headerName="Total"
                width={80}
                sortable
                resizable
                filter
                valueGetter={this.findTotal}
              />
            </AgGridReact>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </>
    );
  }

  findTotal(params) {
    return (
      params.data.stock.damage +
      params.data.stock.inuse +
      params.data.stock.stock
    );
  }

  getHeight() {
    var hgt = window.innerHeight - 175;
    return { height: hgt + "px" };
  }

  showBusy(mode) {
    if (mode === true) {
      this.setState({ spinnerClass: "", dataClass: "collapse" });
    } else {
      this.setState({ spinnerClass: "collapse", dataClass: "" });
    }
  }

  onAddClick = e => {
    //alert(e.target.name);
    this.props.onClick("Add", this.state.dummy);
  };

  onEditClick = e => {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0)
      this.props.onClick("Edit", selectedNodes[0].data);
    else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Select Equipment !!"
      });
    }
  };

  onDisposeClick = e => {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0)
      this.props.onClick("Dispose", selectedNodes[0].data);
    else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Select Equipment !!"
      });
    }
  };
}
